<template>
	<v-container pa-0 class="output-css">
		<v-layout row>
			<v-navigation-drawer
				permanent
				floating
				style="min-width: 250px;"
			>
				<v-container
					fluid
					pa-0
				>
					<v-layout
						row
						wrap
					>
						<v-flex xs12>
							<div class="title text-xs-center pa-3">
								Customize Output CSS
							</div>
						</v-flex>
						<v-flex
							xs12
							pb-2
							class="text-xs-center"
						>
							<!-- <v-btn
								color="secondary"
								@click="editSingle = !editSingle"
							>
								<span v-if="editSingle">Edit All Styles</span>
								<span v-else>Edit Individual Styles</span>
							</v-btn> -->
							<v-btn
								color="primary"
								@click="submit"
							>
								Save
							</v-btn>
							<v-btn
								flat
								class="red--text"
								@click="$emit('close')"
							>
								close
							</v-btn>
						</v-flex>
					</v-layout>
				</v-container>
				<v-divider/>
				<ColorPicker v-model="color"/>
				<div class="text-xs-center">
					<v-btn
						flat
						@click="addText(color.hex)"
					>
						Add Color
					</v-btn>
					<v-divider/>
					<v-menu top>
						<v-btn
							flat
							slot="activator"
						>
							Add Font
						</v-btn>
						<v-list>
							<v-list-tile
								v-for="font in fonts"
								:key="font"
								@click="addText(`font-family: '${font}';`)"
							>
								<v-list-tile-title>{{ font }}</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
					<v-divider/>
				</div>
			</v-navigation-drawer>
			<v-divider vertical/>
			<div class="editor-container">
				<!-- <div class="text-xs-center primary">
					<v-menu
						v-for="(option, index) in customOptions"
						:key="index"
						bottom
					>
						<v-btn
							slot="activator"
							flat
							small
							dark
						>
							{{ option.name }}
						</v-btn>
						<v-list>
							<v-list-tile
								v-for="(item, index) in option.actions"
								:key="index"
								@click="selectOption(item.value)"
							>
								<v-list-tile-title>{{ item.name }}</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</div> -->
				<!-- <div class="editor-toolbar">
					<template v-for="option in mainOptions">
						<v-divider
							v-if="option.name === 'seperator'"
							:key="option.value"
							class="mx-1"
							vertical
						/>
						<a
							v-else
							:key="option.value"
							:class="option.class"
							:title="option.name"
							@click="selectOption(option.value)"
						></a>
					</template>
				</div> -->
				<!-- <template v-if="editSingle">
					<div class="secondary white--text headline pa-2">
						Editing {{ selected.name }}:
					</div>
					<p class="pl-2 pt-2 ma-0 monospace">{{ selected.value }} {</p>
					<textarea
						v-model="selected.data"
						id="textEditor"
						class="py-2 px-4"
						placeholder="Add CSS rules here..."
						spellcheck="false"
					/>
					<p class="pl-2 monospace">}</p>
				</template> -->
				<div v-show="!editSingle" class="full-editor">
					<div class="secondary white--text headline pa-2">
						Editing All Styles:
					</div>
					<textarea ref="fullEditor"/>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
import * as SimpleMDE from 'simplemde/dist/simplemde.min';
import { Chrome } from 'vue-color';

export default {
	props: {
		initial: { type: String, default: '' },
	},
	components: {
		ColorPicker: Chrome,
	},
	data() {
		return {
			css: '',
			editSingle: false,
			markdown: null,
			color: { hex: '#1d97c1' },
			pattern: /(.+?) {([^{}]+(?=}))/g,
			selected: { name: 'Heading 1', value: 'h1' },
			options: null,
			mainOptions: [
				{ name: 'Body', value: 'body', class: 'fa fa-window-maximize' },
				{ name: 'seperator', value: 's0' },
				{ name: 'Heading 1', value: 'h1', class: 'fa fa-header fa-header-x fa-header-1' },
				{ name: 'Heading 2', value: 'h2', class: 'fa fa-header fa-header-x fa-header-2' },
				{ name: 'Heading 3', value: 'h3', class: 'fa fa-header fa-header-x fa-header-3' },
				{ name: 'Paragraph', value: 'p', class: 'fa fa-paragraph' },
				{ name: 'seperator', value: 's1' },
				{ name: 'Bold', value: 'strong', class: 'fa fa-bold' },
				{ name: 'Italic', value: 'em', class: 'fa fa-italic' },
				{ name: 'Strikethrough', value: 'del', class: 'fa fa-strikethrough' },
				{ name: 'seperator', value: 's2' },
				{ name: 'Unordered List', value: 'ul', class: 'fa fa-list-ul' },
				{ name: 'Ordered List', value: 'ol', class: 'fa fa-list-ol' },
				{ name: 'List Element', value: 'li', class: 'fa fa-list' },
				{ name: 'seperator', value: 's3' },
				{ name: 'Link', value: 'a', class: 'fa fa-link' },
				{ name: 'Horizontal Break', value: 'hr', class: 'fa fa-minus' },
			],
			customOptions: [
				{
					name: 'Article',
					actions: [
						{ name: 'Title', value: '.custom-style-article-title' },
						{ name: 'Summary', value: '.custom-style-article-summary' },
						{ name: 'Body', value: '.custom-style-article-body' },
						{ name: 'Author', value: '.custom-style-article-author' },
						{ name: 'Date', value: '.custom-style-article-date' },
						{ name: 'URL', value: '.custom-style-article-url' },
					],
				},
				{
					name: 'Article Shares',
					actions: [
						{ name: 'Facebook Shares', value: '.custom-style-article-shares_facebook' },
						{ name: 'Twitter Shares', value: '.custom-style-article-shares_twitter' },
						{ name: 'Linkedin Shares', value: '.custom-style-article-shares_linkedin' },
						{ name: 'Pinterest Shares', value: '.custom-style-article-shares_pinterest' },
					],
				},
				{
					name: 'Article Custom',
					actions: this.articleCustomActions,
				},
				{
					name: 'Publication',
					actions: [
						{ name: 'Name', value: '.custom-style-pub-name' },
						{ name: 'Logo', value: '.custom-style-pub-logo' },
						{ name: 'URL', value: '.custom-style-pub-url' },
					],
				},
				{
					name: 'Report',
					actions: [
						{ name: 'Name', value: '.custom-style-report-name' },
						{ name: 'Image', value: '.custom-style-report-image' },
					],
				},
				{
					name: 'Project',
					actions: [
						{ name: 'Name', value: '.custom-style-project-name' },
						{ name: 'Image', value: '.custom-style-project-image' },
					],
				},
			],
			fonts: ['Roboto', 'Open Sans', 'Raleway', 'Lato', 'Montserrat', 'Merriweather'],
		};
	},
	watch: {
		editSingle(val) {
			if (val) {
				this.parseCSSString();
				return;
			}
			this.css = this.buildCSSString();
			this.markdown.value(this.css);
			setTimeout(() => {
				this.markdown.codemirror.refresh();
			}, 10);
		},
	},
	created() {
		this.css = this.initial || '';
		//this.initOptions();
		//this.parseCSSString();
	},
	mounted() {
		this.markdown = new SimpleMDE({
			element: this.$refs.fullEditor,
			autoDownloadFontAwesome: false,
			status: false,
			spellChecker: false,
			toolbar: false,
		});
		// Allow SimpleMDE to setup before adding markdown or else text cursor
		// is very wonky
		setTimeout(() => {
			this.markdown.value(this.css);
		}, 400);

		this.markdown.codemirror.on('change', () => {
			const value = this.markdown.value();
			this.css = value;
		});
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		articleCustomActions() {
			return this.project.customFields.map(item => {
				return {
					name: item.label,
					value: `.custom-style-article-${item.name}`
				};
			});
		},
	},
	methods: {
		submit() {
			// if (!this.editSingle) {
			// 	this.parseCSSString();
			// }
			// const css = this.buildCSSString();
			this.$emit('save', this.css);
			this.$emit('close');
		},
		selectOption(value) {
			if (this.editSingle) {
				this.selected = this.options.find(option => option.value === value);
			}
			else {
				const classValue = `${value} {\n\t\n}`;

				this.addToEditor(classValue);
			}
		},
		addText(text) {
			if (this.editSingle) {
				this.insertInTextArea(text);
			}
			else {
				this.addToEditor(text);
			}
		},
		addToEditor(value) {
			if (!this.markdown) {
				return;
			}
			const cm = this.markdown.codemirror;

			cm.replaceSelection(value);
		},
		insertInTextArea(text) {
			const txtarea = document.getElementById('textEditor');
			const scrollPos = txtarea.scrollTop;
			let caretPos = txtarea.selectionStart;

			const front = (txtarea.value).substring(0, caretPos);
			const back = (txtarea.value).substring(txtarea.selectionEnd, txtarea.value.length);
			txtarea.value = front + text + back;
			caretPos += text.length;
			txtarea.selectionStart = caretPos;
			txtarea.selectionEnd = caretPos;
			txtarea.focus();
			txtarea.scrollTop = scrollPos;
			// Resync textarea's value and data value after adding
			this.selected.data = txtarea.value;
		},
		findInOptionsValue(value) {
			return this.options.find(option => option.value === value);
		},
		initOptions() {
			this.options = [...this.mainOptions];
			this.customOptions.forEach((option) => {
				this.options.push(...option.actions);
			});
			this.options.forEach((option) => {
				option.data = '';
			});
			this.selected = this.options[0];
		},
		parseCSSString() {
			let result;
			// eslint-disable-next-line
			while ((result = this.pattern.exec(this.css)) !== null) {
				const foundMain = this.findInOptionsValue(result[1]);
				if (foundMain) {
					const clean = result[2].trim().split('\t').join('');
					foundMain.data = clean;
				}
			}
		},
		buildCSSString() {
			let string = '';
			this.options.forEach((option) => {
				if (option.data.length > 0) {
					const stylesString = `\t${option.data.split('\n').join('\n\t')}`;
					const classString = `${option.value} {\n${stylesString}\n}\n`;
					string = `${string}${classString}`;
				}
			});
			return string;
		},
	},
};
</script>

<style lang="scss">
@import '~simplemde/dist/simplemde.min';
.output-css {
	overflow: hidden;
	max-width: 100%;
}
.full-editor {
	.CodeMirror {
		border: none !important;
		font-family: monospace !important;
	}
}
.options-container {
	display: flex;
	flex-direction: column;
}
.editor-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	.editor-toolbar {
		display: flex;
		justify-content: center;
		text-align: center !important;
		width: 100% !important;
		border: none !important;
		opacity: 1 !important;
		&::after {
			margin: 0 !important;
		}
		&::before {
			margin: 0 !important;
		}
		a {
			width: auto !important;
			min-width: 30px;
			&:hover {
				border-color: transparent !important;
			}
		}
		a.active {
			border-color: transparent !important;
			color: #1d97c1 !important;
		}
		.v-divider {
			height: 18px;
		}
	}
}
.vc-chrome {
	width: 100% !important;
	box-shadow: none !important;
}
.monospace {
	font-family: monospace;
}
#textEditor {
	width: 100%;
	font-family: monospace;
	flex-grow: 1;
	&:focus {
		outline: none;
	}
}
</style>
